import React from 'react'
import Box from '@material-ui/core/Box'
import Typography from '@material-ui/core/Typography'
import SyncAltIcon from '@material-ui/icons/SyncAlt'
import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(1),
    padding: theme.spacing(1.5, 2),
  },
  bucket: {
    display: 'flex',
    alignItems: 'center',
    flexWrap: 'wrap',
    gap: theme.spacing(1.5),
    [theme.breakpoints.only('xs')]: {
      gap: theme.spacing(1),
    },
  },
  bucketLabel: {
    fontWeight: 600,
    minWidth: 100,
    [theme.breakpoints.only('xs')]: {
      minWidth: 'unset',
      flexBasis: '100%',
    },
  },
  subtype: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(0.75),
  },
  swatch: {
    width: 14,
    height: 14,
    borderRadius: 3,
    display: 'inline-block',
    boxSizing: 'border-box',
    flexShrink: 0,
  },
  recurring: {
    backgroundColor: '#E3F2FD',
    border: '1px solid #90CAF9',
  },
  override: {
    backgroundColor: '#FFFFFF',
    backgroundImage:
      'repeating-linear-gradient(135deg, #E3F2FD 0 4px, #FFFFFF 4px 8px)',
    border: '1px solid #90CAF9',
  },
  blocked: {
    backgroundColor: '#F5F5F5',
    border: '1px solid #BDBDBD',
  },
  synced: {
    backgroundColor: '#FFFFFF',
    backgroundImage:
      'repeating-linear-gradient(135deg, #EEEEEE 0 4px, #FFFFFF 4px 8px)',
    border: '1px dashed #BDBDBD',
  },
  syncedIcon: {
    fontSize: 14,
    color: theme.palette.text.secondary,
  },
}))

const Subtype = ({ classes, swatchClass, label, icon }) => (
  <Box className={classes.subtype}>
    <span className={`${classes.swatch} ${swatchClass}`} aria-hidden />
    <Typography variant="body2" color="textSecondary">
      {label}
    </Typography>
    {icon}
  </Box>
)

const Legend = () => {
  const classes = useStyles()
  return (
    <Box className={classes.root}>
      <Box className={classes.bucket}>
        <Typography
          variant="body2"
          color="textPrimary"
          className={classes.bucketLabel}
        >
          Bookable
        </Typography>
        <Subtype
          classes={classes}
          swatchClass={classes.recurring}
          label="Recurring"
        />
        <Subtype
          classes={classes}
          swatchClass={classes.override}
          label="Open time"
        />
      </Box>
      <Box className={classes.bucket}>
        <Typography
          variant="body2"
          color="textPrimary"
          className={classes.bucketLabel}
        >
          Not bookable
        </Typography>
        <Subtype
          classes={classes}
          swatchClass={classes.blocked}
          label="Blocked"
        />
        <Subtype
          classes={classes}
          swatchClass={classes.synced}
          label="Calendar sync"
          icon={<SyncAltIcon className={classes.syncedIcon} />}
        />
      </Box>
    </Box>
  )
}

export default Legend
